import { isUndefined } from 'lodash';

/**
 * Many options as they are passed are optional, but are assigned a default
 * before actually being used. This allows that to be enforced.
 *
 * @param t
 */
export function defaultedOpt<T>(t: T | undefined): T {
  if (isUndefined(t)) {
    throw new Error('An option that was supposed to have a default is undefined.');
  }
  return t;
}
